import React, { useEffect } from "react";
import { useState } from "react";
import { Alert, Button, Card, Col, Form, Row, Modal } from "react-bootstrap";
import { runInnerFunction } from "../../compatManager";
import { getDataReader, RPWDataReader, } from "../../livedataFuncs";
import { useAppSelector } from "../../redux/hooks";
import { lddStateObject } from "../../redux/reducer";
import Loading from "../Loading";
import { prepareTeraViewExport, showDischargeFunction, setTrainingTVWeb, checkForCreateDocumentGeneral } from "./eregFuncs";


const EReg = () => {
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
    let teraviewAcc: string = DataReaderObj.getThirdPartyAccountAttribute('Teraview', 'AccountName');
    let username: string = DataReaderObj.getThirdPartyAccountAttribute('Teraview', 'UserName');
    let teraviewPassword: string = DataReaderObj.getThirdPartyAccountAttribute('Teraview', 'TeraviewPassword');

    let docketIdFlag: string = DataReaderObj.getDockerIdOverwriteFlag();
    let docketId: string = DataReaderObj.getDockerId();
    if (docketIdFlag === '' || docketIdFlag === '0' || docketIdFlag === null || docketIdFlag === undefined) {
        docketId = DataReaderObj.getFileNumber();
    }

    let docketNameFlag: string = DataReaderObj.getDockerNameOverwriteFlag();
    let docketName: string = DataReaderObj.getDockerName();
    if (docketNameFlag === '' || docketNameFlag === '0' || docketNameFlag === null || docketNameFlag === undefined) {
        docketName = DataReaderObj.getReline();
    }

    let lroNum: string = DataReaderObj.getLRONumber();
    if (lroNum === undefined || lroNum === null || lroNum === '') {
        lroNum = DataReaderObj.getRegistryOfficeCode();
    }

    let createTransfer: string = DataReaderObj.getCreateTransfer();
    let createCharge: string = DataReaderObj.getCreateCharge();
    let createDischarge: string = DataReaderObj.getCreateDischarge();
    let docketTransferOptionString: string = DataReaderObj.getERegTransferType();
    let documentGeneralNodes: ajaxslt.XNode[] = DataReaderObj.getDocumentGeneral();
    let psm: 'P' | 'S' | 'M' | 'O' | '' = DataReaderObj.getPSM();
    let nonstandardTransferDefault = false;
    let lawyerID: string = DataReaderObj.getLawyerId();
    const [showDischarge, setShowDischarge] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [useTraining, setUseTraining] = useState<boolean>(false);
    const [inactiveButtons, setInactiveButtons] = useState<boolean>((createTransfer !== '1' && createCharge !== '1' && createDischarge !== '1' && !(checkForCreateDocumentGeneral(documentGeneralNodes))) ? true : false);
    const [additionalInfo, setAdditionalInfo] = useState<boolean>(false);
    const [additionalInfoSrc, setAdditionalInfoSrc] = useState<string>("");

    useEffect(() => {
        setShowDischarge(showDischargeFunction((livedataRootContainer.dataRoot as any) as ajaxslt.XNode));
    }, [livedataRootContainer]);

    useEffect(() => {
        if (additionalInfoSrc !== null) {
            if (additionalInfoSrc > '' && additionalInfoSrc.indexOf('data:image/png;base64') !== -1) {
                setAdditionalInfo(true);
            } else {
                setAdditionalInfo(false);
            }
        }
    }, [additionalInfoSrc])

    
    const [show, setShow] = useState(false);

    const AdditionalInfoClose = () => setShow(false);
    const AdditionalInfoShow = () => setShow(true);

    const [docketTransferBoolean, setDocketTransferBoolean] = useState<boolean>((createTransfer === '1'));
    const [docketTransferOption, setDocketTransferOption] = useState<string>(docketTransferOptionString);
    if (docketTransferOptionString !== null && docketTransferOptionString !== undefined && docketTransferOptionString !== '')
        nonstandardTransferDefault = true;
    const [nonStandardTransfer, setNonStandardTransfer] = useState<boolean>(nonstandardTransferDefault);
    return (
        <>
            {isLoading && <Loading />}
            <Card onChange={
                () => {
                    if (
                        (window.document.getElementById('TeraviewTransferCheckbox') as any)?.checked ||
                        (window.document.getElementById('TeraviewCreateChargeCheckbox') as any)?.checked ||
                        (window.document.getElementById('TeraviewCreateDischargeCheckbox') as any)?.checked ||
                        (window.document.querySelectorAll("[id*='DocumentGeneral']:checked").length > 0)
                    ) {
                        setInactiveButtons(false);
                    } else {
                        setInactiveButtons(true);
                    }
                }
            }>
                <Card.Header>
                    <Col>
                        <Card.Title>Export to e-reg™</Card.Title>
                    </Col>

                    <Col className="align-right">
                        <span className="required">*</span>
                        <span>required</span>
                    </Col>
                </Card.Header>

                <Card.Body onChange={
                    () => {
                        let teraviewDockerId = (document.getElementById('TeraviewDocketID') as HTMLInputElement).value;
                        DataReaderObj.setDockerId(teraviewDockerId);

                        let teraviewDockerName = (document.getElementById('TeraviewDocketName') as HTMLInputElement).value;
                        DataReaderObj.setDockerName(teraviewDockerName);

                        let teraviewLRO = (document.getElementById('TeraviewLRONumber') as HTMLInputElement).value;
                        DataReaderObj.setLRONumber(teraviewLRO);

                        if (psm !== 'M') {
                            let teraviewTransfer = (document.getElementById('TeraviewTransferCheckbox') as HTMLInputElement).checked;
                            if (teraviewTransfer) {
                                DataReaderObj.setTeraviewTransfer('1');
                                setDocketTransferBoolean(true);
                            }
                            else {
                                DataReaderObj.setTeraviewTransfer('0');
                                setDocketTransferBoolean(false);
                            }
                        }
                        runInnerFunction("SetPageDirty", null);
                    }
                } >
                    {
                        (teraviewAcc <= '' || teraviewAcc === null || teraviewAcc === undefined)
                            ||
                            (username <= '' || username === null || username === undefined)
                            ||
                            (teraviewPassword <= '' || teraviewPassword === null || teraviewPassword === undefined)
                            ?
                            <Row>
                                <Col>
                                    <Alert variant="danger">Your Teraview credentials are missing some information. Please update them in User Settings.</Alert>
                                </Col>
                            </Row>
                            :
                            null
                    }

                    <Alert variant="warning" style={{ display: additionalInfo ? '' : 'none' }}>
                        <Row style={{ alignItems: 'center' }}>
                            <Col>The connection was interupted, but the export may have been successful.</Col> 
                            <Col className="align-right col-2"><Button variant="warning" onClick={AdditionalInfoShow}>More Info</Button></Col>
                        </Row>
                    </Alert>

                    <Modal show={show} onHide={AdditionalInfoClose} className="modal-list" size={'xl'} scrollable>
                        <Modal.Header closeButton>
                            <Modal.Title>Additional Information</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <img src={additionalInfoSrc} style={{ width: '100%', }} id={'E-Reg-Additonal-Info'} />
                        </Modal.Body>
                    </Modal>

                    <Row>
                        <Col>
                            <h3>Docket Information</h3>
                        </Col>
                    </Row>

                    <Row className="mb-5">
                        <Col className="col-4">
                            <Form.Label>Docket ID<span className="required">*</span></Form.Label>
                            <Form.Control defaultValue={docketId} id="TeraviewDocketID"></Form.Control>
                        </Col>

                        <Col className="col-4">
                        </Col>

                        <Col className="col-2">
                            <Form.Label>LRO #<span className="required">*</span></Form.Label>
                            <Form.Control defaultValue={lroNum} id="TeraviewLRONumber" onChange={
                                (ele) => { DataReaderObj.setLRONumber(ele.target.value) }
                            }></Form.Control>
                        </Col>
                    </Row>

                    <Row className="mb-5">
                        <Col className="col-8">
                            <Form.Label>Docket Name<span className="required">*</span></Form.Label>
                            <Form.Control defaultValue={docketName} id="TeraviewDocketName"></Form.Control>
                        </Col>
                    </Row>

                    <Row className="mb-5">
                        <Col>
                            <Form.Label>Instruments</Form.Label>
                            {psm !== 'M' && <Form.Check id="TeraviewTransferCheckbox" defaultChecked={createTransfer === '1'} label={'Transfer'} onChange={(ele) => {
                                setDocketTransferBoolean(ele.target.checked);
                                if (ele.target.checked) {
                                    DataReaderObj.setCreateTransfer('1');
                                } else {
                                    DataReaderObj.setCreateTransfer('0');
                                    DataReaderObj.setTeraviewTransferOption('');
                                    setNonStandardTransfer(false);
                                    setDocketTransferOption(null);
                                }
                            }} />
                            }

                            <Form.Check label={'Charge'} id="TeraviewCreateChargeCheckbox" defaultChecked={(createCharge === '1')} onChange={(ele) => {
                                if (ele.target.checked)
                                    DataReaderObj.setCreateCharge('1');
                                else
                                    DataReaderObj.setCreateCharge('0');
                            }} />
                            {showDischarge &&
                                <Form.Check id="TeraviewCreateDischargeCheckbox" defaultChecked={(createDischarge === '1')} onChange={(ele) => {
                                    if (ele.target.checked)
                                        DataReaderObj.setCreateDischarge('1');
                                    else
                                        DataReaderObj.setCreateDischarge('0');
                                }} label={'Discharge'} />
                            }
                            {(documentGeneralNodes.length) > 0 && documentGeneralNodes[0].getAttribute('type') !== '' && documentGeneralNodes[0].getAttribute('type') !== null && documentGeneralNodes[0].getAttribute('type') !== undefined &&
                                (
                                    <>
                                        <br />
                                        <Form.Label>Document General</Form.Label>
                                        {
                                            documentGeneralNodes.map((node, index) => {
                                                if (node.getAttribute('type') !== '' && node.getAttribute('type') !== null && node.getAttribute('type') !== undefined) {
                                                    return makeDocumentGeneralCheckbox(node, index);
                                                }
                                                return null;
                                            })
                                        }
                                    </>
                                )
                            }

                        </Col>

                        <Col>

                            {docketTransferBoolean &&
                                <>
                                    <Form.Label>Non-standard Transfer</Form.Label>
                                    <Form.Check defaultChecked={nonStandardTransfer} name="NonStandardTransfer" onChange={(e) => {
                                        setNonStandardTransfer(e.target.checked);
                                        setDocketTransferOption('');
                                        DataReaderObj.setTeraviewTransferOption('');
                                    }} />
                                </>
                            }
                        </Col>

                        <Col>
                            {docketTransferBoolean && nonStandardTransfer ?
                                <>
                                    <Form.Label>Non-standard Transfer Type</Form.Label>
                                    <Form.Select onChange={(ele) => {
                                        setDocketTransferOption(ele.target.value);
                                        DataReaderObj.setTeraviewTransferOption(ele.target.value);
                                        runInnerFunction("SetPageDirty", null);
                                    }} defaultValue={docketTransferOption} >
                                        <option>Please select</option>
                                        <option value="T">Transfer</option>
                                        <option value="TESMT">Transfer Easement</option>
                                        <option value="TLP">Transfer By Partnership</option>
                                        <option value="TPR">Transfer By Personal Representative</option>
                                        <option value="TPSA">Transfer: Power of Sale</option>
                                    </Form.Select>
                                </>
                                :
                                <></>
                            }
                        </Col>
                    </Row>

                    {(lawyerID === '387' || lawyerID === '1000321' || lawyerID === '1882') &&
                        <Row className="mb-5">
                            <Col>
                                <Form.Label>LDD Internal Use</Form.Label>
                                <Form.Check id="TeraviewTrainingCheckbox" onChange={(ele) => {
                                    setUseTraining(ele.target.checked);
                                }
                                } label={'Training TVWeb'} />
                            </Col>
                        </Row>
                    }

                    <Row>
                        <Col className="align-right">
                            <Button disabled={inactiveButtons ? true : false} variant="outline-primary" onClick={() => prepareTeraViewExport('ViewXML', DataReaderObj, (livedataRootContainer.dataRoot as any) as ajaxslt.XNode, setAdditionalInfoSrc)}>View XML</Button>
                            <Button disabled={inactiveButtons ? true : false} variant="outline-primary" onClick={() => prepareTeraViewExport('SaveXML', DataReaderObj, (livedataRootContainer.dataRoot as any) as ajaxslt.XNode, setAdditionalInfoSrc)}>Save XML</Button>
                            <Button disabled={inactiveButtons ? true : false} variant="primary" onClick={async () => {
                                setIsLoading(true);
                                await setTrainingTVWeb(useTraining);
                                await prepareTeraViewExport('ExportTVWeb', DataReaderObj, (livedataRootContainer.dataRoot as any) as ajaxslt.XNode, setAdditionalInfoSrc);
                                setIsLoading(false);
                            }
                            }>Export</Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </>
    )
}

function makeDocumentGeneralCheckbox(node: ajaxslt.XNode, index: number) {
    let isChecked: boolean = node.getAttribute('CreateDocumentGeneral') === '1';
    return (
        (<Form.Check label={node.getAttribute('type')} id={`DocumentGeneral-Checkbox-${index}`} key={`DocumentGeneral-${index}`} defaultChecked={isChecked} onChange={(ele) => {
            node.setAttribute('CreateDocumentGeneral', (ele.target.checked ? '1' : '0'));
        }} />
        )
    )
}

export default EReg;